import React from "react";
import clsx from "clsx";
import styles from "./styles.module.scss";
import { CalenderIconComponent } from "components/ui/CalenderIconComponent";
import moment from "moment";

export interface ContentInfoSectionProps {
  title: string;
  content: string;
  className?: string;
  titleClassName?: string;
  contentClassName?: string;
}

interface CategoryPillProps {
  text: string;
}

interface DateInfoDisplayProps {
  date: string;
  time: string;
  isCompleted?: boolean;
}

export const DateInfoDisplay: React.FC<DateInfoDisplayProps> = ({
  date,
  time,
  isCompleted,
}) => {
  const dateMoment = moment(date);
  const formattedDate = dateMoment.format("dddd Do MMMM");

  const containerClassName = isCompleted
    ? `${styles["date-info-container"]} ${styles["date-info-container-completed"]}`
    : styles["date-info-container"];

  return (
    <div className={containerClassName}>
      <CalenderIconComponent date={date} isInPast={isCompleted} />
      <div className={styles["date-info-text"]}>
        <div className={styles["date-info-formatted-date"]}>
          {formattedDate}
        </div>
        <div className={styles["date-info-time"]}>{time}</div>
      </div>
    </div>
  );
};

export const CategoryPill: React.FC<CategoryPillProps> = ({ text }) => {
  const textCapitalized =
    text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  return <div className={styles["category-pill"]}>{textCapitalized}</div>;
};

export const ContentInfoSection: React.FC<ContentInfoSectionProps> = ({
  title,
  content,
  className = "",
  titleClassName = "",
  contentClassName = "",
}) => {
  return (
    <div className={clsx(styles["content-info-section"], className)}>
      <p className={clsx(styles["content-info-section-title"], titleClassName)}>
        {title}
      </p>
      <p
        className={clsx(
          styles["content-info-section-details"],
          contentClassName
        )}
      >
        {content}
      </p>
    </div>
  );
};
